<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: block" [class.fill]="true">
				<div
					class="fill"
					style="background-color: gainsboro"
					[style.display]="'grid'"
					[style.gridTemplateRows]="'auto 1fr auto'"
					[style.gridTemplateColumns]="'auto clamp(200px, 80%, 1200px) auto'"
					[style.gridTemplateAreas]='&apos;"header header header" "left main right" "footer footer footer"&apos;'
				>
					<div
						style="
							background: linear-gradient(to top, gainsboro 0%, white 10%);
							grid-area: header;
						"
						[id]="'header'"
						data-content-area="header"
						data-defined-in="Common.FancyLayout"
					>
						<div
							class="layout-block"
							style="align-items: center"
							[style.align-items]="'inherit'"
							[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
							[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
							[style.gap]="'1em'"
						>
							<a [href]="'/' | safeUrl" target="_self">
								<img [src]="'/master/Llama/Common.Logo/generic_logo.png'" />
							</a>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 1' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 2' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 3' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
						</div>
					</div>

					<div
						style="padding: 1em; overflow-y: auto; grid-area: main"
						[id]="'main-content'"
						data-content-area="main"
						data-defined-in="Common.FancyLayout"
					>
						<ng-template
							[ngTemplateOutlet]="getContentTemplate('content')"
							[ngTemplateOutletContext]="{ $scope, $formDirective, $disabled }"
						></ng-template>
					</div>

					<div
						style="
							background: linear-gradient(to bottom, gainsboro 0%, white 10%);
							padding: 0.5em;
							grid-area: footer;
						"
						[id]="'footer'"
						data-content-area="footer"
						data-defined-in="Common.FancyLayout"
					>
						<span
							[innerHtml]="'Footer' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
